import React, { useState, useEffect } from 'react';

const FilterSection = ({ fields, onFilter, resetFilters }) => {
  const initialState = fields.reduce((acc, field) => {
    acc[field.name] = field.defaultValue || '';
    return acc;
  }, {});

  const [filters, setFilters] = useState(initialState);

  // Reset the filters when resetFilters is triggered
  useEffect(() => {
    if (resetFilters) {
      setFilters(initialState); // Reset the filters to initial state
    }
  }, [resetFilters, initialState]); // Depend on resetFilters and initialState

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleRadioChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    onFilter(filters);
  };

  const renderField = (field) => {
    switch (field.type) {
      case 'text':
      case 'date':
        return (
          <input
            type={field.type}
            name={field.name}
            placeholder={field.placeholder}
            value={filters[field.name]} // Bind input value to state
            className="border p-2 w-full rounded-md"
            onChange={handleChange}
          />
        );
      case 'select':
        return (
          <select
            name={field.name}
            value={filters[field.name]} // Bind select value to state
            className="border p-2 w-full rounded-md"
            onChange={handleChange}
          >
            <option value="" disabled>{field.placeholder || 'Select'}</option>
            {field.options.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        );
      case 'range':
        return (
          <>
            <input
              name={field.name}
              type="range"
              min={field.min || 0}
              max={field.max || 100}
              value={filters[field.name]} // Bind range value to state
              onChange={handleChange}
              className="w-full"
            />
            <p className="text-sm text-gray-500">Selected: {filters[field.name]}</p>
          </>
        );
      case 'radio':
        return (
          <div className="flex gap-4 mt-1">
            {field.options.map((opt) => (
              <label key={opt} className="flex items-center">
                <input
                  type="radio"
                  name={field.name}
                  value={opt}
                  checked={filters[field.name] === opt} // Ensure the radio is checked
                  onChange={() => handleRadioChange(field.name, opt)}
                />
                <span className="ml-1">{opt}</span>
              </label>
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-white shadow p-6 rounded-md my-4">
      <h2 className="text-lg font-semibold mb-4 text-gray-700">Filters</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {fields.map((field) => (
          <div key={field.name}>
            <label className="block text-sm font-medium text-gray-600">{field.label}</label>
            {renderField(field)}
          </div>
        ))}
      </div>

      <div className="mt-6 text-right">
        <button
          className="bg-teal-600 text-white px-6 py-2 rounded hover:bg-teal-700"
          onClick={applyFilters}
        >
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default FilterSection;


// import React, { useState } from 'react';

// const FilterSection = ({ fields, onFilter, resetFilters }) => {
//   const initialState = fields.reduce((acc, field) => {
//     acc[field.name] = field.defaultValue || '';
//     return acc;
//   }, {});

//   const [filters, setFilters] = useState(initialState);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleRadioChange = (name, value) => {
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const applyFilters = () => {
//     onFilter(filters);
//   };

//   const renderField = (field) => {
//     switch (field.type) {
//       case 'text':
//       case 'date':
//         return (
//           <input
//             type={field.type}
//             name={field.name}
//             placeholder={field.placeholder}
//             className="border p-2 w-full rounded-md"
//             onChange={handleChange}
//           />
//         );
//       case 'select':
//         return (
//           <select
//             name={field.name}
//             className="border p-2 w-full rounded-md"
//             onChange={handleChange}
//             defaultValue=""
//           >
//             <option value="" disabled>{field.placeholder || 'Select'}</option>
//             {field.options.map((opt) => (
//               <option key={opt} value={opt}>{opt}</option>
//             ))}
//           </select>
//         );
//       case 'range':
//         return (
//           <>
//             <input
//               name={field.name}
//               type="range"
//               min={field.min || 0}
//               max={field.max || 100}
//               value={filters[field.name]}
//               onChange={handleChange}
//               className="w-full"
//             />
//             <p className="text-sm text-gray-500">Selected: {filters[field.name]}</p>
//           </>
//         );
//       case 'radio':
//         return (
//           <div className="flex gap-4 mt-1">
//             {field.options.map((opt) => (
//               <label key={opt} className="flex items-center">
//                 <input
//                   type="radio"
//                   name={field.name}
//                   value={opt}
//                   onChange={() => handleRadioChange(field.name, opt)}
//                 />
//                 <span className="ml-1">{opt}</span>
//               </label>
//             ))}
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="bg-white shadow p-6 rounded-md my-4">
//       <h2 className="text-lg font-semibold mb-4 text-gray-700">Filters</h2>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//         {fields.map((field) => (
//           <div key={field.name}>
//             <label className="block text-sm font-medium text-gray-600">{field.label}</label>
//             {renderField(field)}
//           </div>
//         ))}
//       </div>

//       <div className="mt-6 text-right">
//         <button
//           className="bg-teal-600 text-white px-6 py-2 rounded hover:bg-teal-700"
//           onClick={applyFilters}
//         >
//           Apply Filters
//         </button>
//       </div>
//     </div>
//   );
// };

// export default FilterSection;


// import React, { useState } from 'react';

// const FilterSection = ({ onFilter }) => {
//   const [filters, setFilters] = useState({
//     name: '',
//     ID:'',
//     diagnosis: '',
//     age: 0,
//     gender: '',
//     clinician: '',
//     checkupDate: '',
//   });

//   const diagnoses = ['Diabetes', 'Hypertension', 'Heart Failure'];
//   const clinicians = ['Dr. A', 'Dr. B', 'Dr. C'];
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleRadioChange = (e) => {
//     setFilters((prev) => ({ ...prev, gender: e.target.value }));
//   };

//   const applyFilters = () => {
//     onFilter(filters); // send filters to parent
//   };

//   return (
//     <div className="bg-white shadow p-6 rounded-md my-4">
//       <h2 className="text-lg font-semibold mb-4 text-gray-700">Filter Patients</h2>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//         <div>
//           <label className="block text-sm font-medium text-gray-600">Patient Name</label>
//           <input
//             name="name"
//             placeholder="Enter patient name"
//             className="border p-2 w-full rounded-md"
//             onChange={handleChange}
//           />
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-600">Patient ID</label>
//           <input
//             id="ID"
//             placeholder="Enter patient ID"
//             className="border p-2 w-full rounded-md"
//             onChange={handleChange}
//           />
//         </div>


//         <div>
//           <label className="block text-sm font-medium text-gray-600">Diagnosis</label>
//           <select
//             name="diagnosis"
//             className="border p-2 w-full rounded-md"
//             onChange={handleChange}
//             defaultValue=""
//           >
//             <option value="" disabled>Select diagnosis</option>
//             {diagnoses.map((d) => (
//               <option key={d} value={d}>{d}</option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-600">Assigned Clinician</label>
//           <select
//             name="clinician"
//             className="border p-2 w-full rounded-md"
//             onChange={handleChange}
//             defaultValue=""
//           >
//             <option value="" disabled>Select Clinician</option>
//             {clinicians.map((c) => (
//               <option key={c} value={c}>{c}</option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-600">Checkup Date</label>
//           <input
//             name="checkupDate"
//             type="date"
//             className="border p-2 w-full rounded-md"
//             onChange={handleChange}
//           />
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-600">Age</label>
//           <input
//             name="age"
//             type="range"
//             min="1"
//             max="100"
//             value={filters.age}
//             onChange={handleChange}
//             className="w-full"
//           />
//           <p className="text-sm text-gray-500">Selected Age: {filters.age}</p>
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-600">Gender</label>
//           <div className="flex gap-4 mt-1">
//             <label className="flex items-center">
//               <input type="radio" name="gender" value="Male" onChange={handleRadioChange} />
//               <span className="ml-1">Male</span>
//             </label>
//             <label className="flex items-center">
//               <input type="radio" name="gender" value="Female" onChange={handleRadioChange} />
//               <span className="ml-1">Female</span>
//             </label>
//           </div>
//         </div>
//       </div>

//       <div className="mt-6 text-right">
//         <button
//           className="bg-teal-600 text-white px-6 py-2 rounded hover:bg-teal-700"
//           onClick={applyFilters}
//         >
//           Apply Filters
//         </button>
//       </div>
//     </div>
//   );
// };

// export default FilterSection;